module.exports = __webpack_public_path__ + "assets/img/蘑菇小兵.7cc2a09d.jpg";